import {
  ConnectionCardLoading,
  Grid,
  TableEmpty,
  Grow,
} from '@yuno/design-system-web'
import styled from '@emotion/styled'
import { useEffect } from 'react'
import { ConnectionDrawerForm } from '../../components/connection-drawer-form'
import { ConnectionCard } from '../../components/connection-card'
import useConnect from '../../hooks/connect.hook'
import { storage } from '@yuno/dashboard-container-mfe'
import CategoryTypeFilter from '../../components/filters/category-type-filter'
import CountryCoverageFilter from '../../components/filters/country-coverage-filter'
import { FiltersInputSearch } from '../../components/filters/input-search'
import emptyImg from '../../assets/empty-state.svg'
import { useTranslation } from 'react-i18next'

const WrapperLoading = styled.div(() => ({
  display: 'flex',
}))

const WrapperFilters = styled.div(() => ({
  display: 'flex',
  marginBottom: '24px',
}))

const ExplorePage = () => {
  const {
    openDrawerForm,
    drawerData,
    handleSubmit,
    handleCloseDrawer,
    setProviderId,
    postConnection,
    connections,
    resetForm,
    isLoadingConnection,
    handleChangeCountry,
    paymentMethods,
    providerResponse,
    validating,
    validAccounts,
    postValidateAccountsSuccess,
    handleSubmitConfirm,
    postValidateAccountsError,
    actualAccount,
    handleClickReturn,
    valuesForm,
    integrationTypes,
  } = useConnect()
  
  const { t } = useTranslation()

  useEffect(() => {
    storage.removeItem('tempValuesForm')
  }, [])

  return (
    <>
      <FiltersInputSearch />
      {drawerData?.id && (
        <ConnectionDrawerForm
          error={postConnection?.error?.response.data.message}
          data={postConnection.data}
          status={postConnection.status}
          handleSubmit={handleSubmit}
          category={drawerData?.category}
          name={drawerData?.name}
          icon={drawerData?.icon}
          description={drawerData?.description}
          fields={drawerData?.fields}
          paymentMethods={paymentMethods}
          open={openDrawerForm}
          providerId={drawerData?.id}
          countries={drawerData?.countries}
          setupInstructions={drawerData?.setup_instructions}
          onSecondaryAction={handleCloseDrawer}
          onPrimaryAction={resetForm}
          onClose={handleCloseDrawer}
          loading={postConnection.isLoading}
          handleChangeCountry={handleChangeCountry}
          isAsync={providerResponse.async}
          validating={validating}
          validAccounts={validAccounts}
          postValidateAccountsSuccess={postValidateAccountsSuccess}
          postValidateAccountsError={postValidateAccountsError}
          handleSubmitConfirm={handleSubmitConfirm}
          actualAccountName={actualAccount?.name}
          handleClickReturn={handleClickReturn}
          valuesForm={valuesForm}
          instructions={drawerData?.instructions}
          testKeyValues={drawerData?.test_parameters}
          currentMode={'create'}
          providerResponse={providerResponse.data}
          integrationTypes={integrationTypes}
        />
      )}
      
      <WrapperFilters>
        <CategoryTypeFilter />
        <CountryCoverageFilter />
      </WrapperFilters>
      {isLoadingConnection ? (
        <WrapperLoading>
          <ConnectionCardLoading />
          <ConnectionCardLoading />
          <ConnectionCardLoading />
        </WrapperLoading>
      ) : (
        <Grid
          container
          wrap="wrap"
          flexDirection="row"
          justifyContent="flex-start"
        >
          {connections?.length > 0 &&
            connections
              ?.filter(({ active }) => active)
              .map((item, index) => (
                <Grow in={true} timeout={(index + 1) * 250} key={`key-grid-${index}`}>
                  <Grid xs={12} md={6} lg={4} xl={4}>
                    <ConnectionCard
                      connection={item}
                      onClick={setProviderId.bind(null, item.id)}
                    />
                  </Grid>
                </Grow>
              ))}

          {connections?.length === 0 && (
            <TableEmpty
              icon={emptyImg}
              title={t('noResults')}
              subtitle={t('noResultsFinal')}
            />
          )}

          {/* wrapper donde se ubica el boton de agregar otra conexión. funcionalidad que se agregara en un futuro   */}
          {/* <WrapperGrid xs={4}>
            <Card
              label={<CustomCard />}
              title={
                <PlusIconDiv>
                  <Icon
                    color={theme.palette.grey[5]}
                    name="PlusCircle"
                    size="24"
                  />
                </PlusIconDiv>
              }
            />
          </WrapperGrid> */}
        </Grid>
      )}
    </>
  )
}
export default ExplorePage
